import Backend from "../Backend";

let _serverConfigCache = null;

class AdminData {
    static getServerConfig() {
        if (!_serverConfigCache) {
            _serverConfigCache = Backend.getData('/api/config');
        }
        return _serverConfigCache;
    }

    static getUsers() {
        return Backend.getData('/api/admin/users');
    }

    static createUser(data) {
        return Backend.postData('/api/admin/users', data);
    }

    static getUserRelations(userId) {
        return Backend.getData(`/api/admin/users/${userId}/relations`);
    }

    static updateUserRelations(userId, targetUserIds) {
        return Backend.putData(`/api/admin/users/${userId}/relations`, { targetUserIds });
    }

    static getTenants() {
        return Backend.getData('/api/tenants');
    }

    static createTenant(data) {
        return Backend.postData('/api/tenants', data);
    }

    static updateTenant(id, data) {
        return Backend.putData(`/api/tenants/${id}`, data);
    }

    static setTenantHidden(tenantId, hidden) {
        return Backend.putData(`/api/tenants/${tenantId}/hidden`, { hidden });
    }

    static setTenantLocked(tenantId, locked) {
        return Backend.putData(`/api/tenants/${tenantId}/locked`, { locked });
    }

    static getOrgCodes(tenantId) {
        return Backend.getData(`/api/tenants/${tenantId}/orgcodes`);
    }

    static addOrgCode(tenantId, orgCode) {
        return Backend.postData(`/api/tenants/${tenantId}/orgcodes`, { TOC_OrgCode: orgCode });
    }

    static removeOrgCode(tenantId, orgCode) {
        return Backend.deleteData(`/api/tenants/${tenantId}/orgcodes/${orgCode}`);
    }

    static getRoles() {
        return Backend.getData('/api/admin/roles');
    }

    static updateUser(userId, currentTenantId, data) {
        return Backend.putData(`/api/admin/users/${userId}`, { currentTenantId, ...data });
    }

    static assignRole(userId, tenantId, role, diszis) {
        return Backend.putData(`/api/admin/users/${userId}/role`, { role, tenantId, diszis });
    }

    static getDiszis(tenantId) {
        return Backend.getData(`/api/admin/diszis?tenantId=${tenantId}`);
    }

    static getUserPermissions(userId, tenantId) {
        return Backend.getData(`/api/admin/users/${userId}/permissions?tenantId=${tenantId}`);
    }

    static updateUserPermissions(userId, tenantId, permissions) {
        return Backend.putData(`/api/admin/users/${userId}/permissions`, { permissions, tenantId });
    }

    static assumeRole(role, tenantId) {
        return Backend.postData('/api/admin/assume-role', { role, tenantId });
    }

    static setAdminFlag(userId, isAdmin) {
        return Backend.putData(`/api/admin/users/${userId}/admin`, { isAdmin });
    }

    static getEmployees() {
        return Backend.getData('/api/admin/employees');
    }

    static setMigrationTenant(employeeId, tenantId) {
        return Backend.putData(`/api/admin/employees/${employeeId}/migration-tenant`, { tenantId });
    }

    static impersonateUser(userId, tenantId) {
        return Backend.postData(`/api/admin/impersonate/${userId}`, { tenantId: tenantId ?? null });
    }

    static getAuditLog(page = 0) {
        return Backend.getData(`/api/admin/audit?page=${page}`);
    }
}

export default AdminData;
